import './EventCarouselHeader.scss'

type EventCarouselHeaderProps = {
  allEvents?: string
  anchorLabel: string
  eventsPageLink?: string
  seoHeadingElement?: string
  title: string
  titleId: string
}

export const EventCarouselHeader = ({
  allEvents,
  anchorLabel,
  eventsPageLink,
  seoHeadingElement = 'h2',
  title,
  titleId,
}: EventCarouselHeaderProps) => {
  const HeadingTag = seoHeadingElement as keyof JSX.IntrinsicElements

  return (
    <header className="cmp-carousel__header u-container-width">
      {title && (
        <HeadingTag id={titleId} data-anchor-label={anchorLabel || ''} className="cmp-title__text cmp-carousel__header--title h2">
          {title}
        </HeadingTag>
      )}

      {eventsPageLink && (
        <a className="cmp-button cmp-carousel__header--allevents-link" href={eventsPageLink} data-dm="events.link">
          <span className="cmp-button__text">{allEvents}</span>
          <span className="cmp-button__icon cmp-button__icon--keyboard_arrow_right icon--sm"></span>
        </a>
      )}
      {!eventsPageLink && <span className="cmp-carousel__header--allevents-link"></span>}
    </header>
  )
}
